import { TreeNode } from "primeng/api";
import { TreeIcon } from "src/modules/sm-base/models/tree-icon.model";

export interface TreeNode2<T = any> extends TreeNode<T> {

    sortText?: string;
    icons?: TreeIcon[];
    additional?: any;
}

export namespace TreeNode2 {
    export function g(key: string, gg: () => TreeNode2): [string, () => TreeNode2] {
        return [key, gg];
    }

    export function m<T>(label: string, data: any = null, additional: Partial<TreeNode2<T>> = {}): TreeNode2<T> {
        return {
            label,
            data,
            ...additional
        };
    }
}